import ResetPasswordTemplate from "templates/auth/resetPassword";

export default function ResetPasswordPage() {
  return <ResetPasswordTemplate />;
}
